
import { Component, VModel, Prop } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ObservationMixin from '@/_mixins/observation'
import CalendarPicker from '@/components/Picker/Calendar/Calendar.vue'

@Component({
    mixins: [ObservationMixin],
    components: { CalendarPicker },
    inheritAttrs: false,
})
export default class PeriodFilter extends Mixins<MixinInterface>(ObservationMixin) {
    @VModel() filter!: Record<string, any>
    @Prop() itemType!: string
    @Prop() max!: string

    get timeZone() {
        return this.guessTimezone()
    }

    get periodDisplayValues() {
        let text: any = ''
        if (this.filter.period) {
            text = this.getTranslation(`calendar.period_last_${this.filter.period}_days`)
        } else if (this.filter.ge || this.filter.le) {
            if (!this.filter.le) {
                text = `from ${this.generalFormat(this.filter.ge, this.timeZone, 'DD.MM.YYYY')}`
            } else if (!this.filter.ge) {
                text = `before ${this.generalFormat(this.filter.le, this.timeZone, 'DD.MM.YYYY')}`
            } else {
                text = `${this.generalFormat(
                    this.filter.ge,
                    this.timeZone,
                    'DD.MM.YYYY'
                )} - ${this.generalFormat(this.filter.le, this.timeZone, 'DD.MM.YYYY')}`
            }
        }
        return text
    }

    menu = false
}
